import slider from '../helpers/slider';
import config from '../config';
interface IRevealConfig {
  selectors: IRevealSelectors,
  classNames: IRevealClassNames
}

interface IRevealClassNames {
  hide: string
}

interface IRevealSelectors {
  hide: string
}

class Reveal {
  
  private config: IRevealConfig;
  
  constructor() {
    this.config = {
      classNames: {
        hide: 'hide'
      },
      selectors: {
        hide: '.hide'
      }
    }
  }
  
  public closestHideClassName(htmlElement: HTMLElement) {
    htmlElement.closest(this.config.selectors.hide).classList.remove(this.config.classNames.hide);
  }
}

export default new Reveal();